export default function resetMaxValueByOffset(max: number, offset: number) {
  return (value: number) => {
    if (value >= max) {
      return max - offset;
    }
    return value;
  };
}
